/**
 * 運営のお知らせの種類を、画面に出す日本語の札にする。
 *
 * **運営の画面（お知らせ配信）とダッシュボードで同じものを使う。**
 * ダッシュボードは種類のコード（SYSTEM・UPDATE）をそのまま札に出していて、
 * 全利用者が毎日英語の内部コードを見ていた（束18）。
 *
 * 知らない種類は「運用の連絡」にする。運営の画面が前からそうしている。
 */
export const NOTICE_CATEGORIES = [
  { value: 'SYSTEM', label: '運用の連絡' },
  { value: 'UPDATE', label: '機能の変更' }
]

export function noticeCategoryLabel (category) {
  return category === 'UPDATE' ? '機能の変更' : '運用の連絡'
}
